import { Expose } from 'class-transformer';

export class ModelUser {
    @Expose()
    firstName: string;

    @Expose()
    lastName: string;

    @Expose()
    email: string;

    @Expose()
    displayName: string;

    @Expose()
    dateOfBirth: string;

    @Expose()
    phoneNumber: string;

    @Expose()
    token: string;

    @Expose()
    imageUrl: string;

    @Expose()
    balance: number;

    @Expose()
    freePlay: number;

    @Expose()
    isUnityLinked: boolean;

    @Expose()
    totalUnityPoints: number;

    @Expose()
    unityAccountNumber: string;

    @Expose()
    unityTier: string;

    @Expose()
    totalTierCredits: number;

    @Expose()
    uid: string;
}
